@if (!criteria.BusinessId) {
<brt-business-list (selected)="router.navigate([basePath, 'menu', $event.Id])"></brt-business-list>
} @else {
<div class="card">
  <h5>Menu List</h5>
  <p-table #dt1 [value]="menus" dataKey="id" [rows]="criteria.Size" [rowHover]="true" styleClass="p-datatable-gridlines"
    [paginator]="true"  [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]" [totalRecords]="total" [globalFilterFields]="[]" [loading]="loading" responsiveLayout="scroll"
    [lazy]="true" (onLazyLoad)="load($event)" (onRowReorder)="setOrder()">
    <ng-template pTemplate="caption">
      <div class="tw-flex tw-flex-wrap tw-gap-2 tw-items-center">
        <span class="p-input-icon-left tw-grow">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="criteria.Query" placeholder="Search menu by name, tag, or ID"
            class="tw-w-full" (ngModelChange)="load()" />
        </span>
        <!-- <button pButton label="Add" class="p-button-outlined mr-2" icon="pi pi-plus"
          [routerLink]="[basePath, 'menu',businessId,'add']"></button> -->
        <button pButton label="Add" class="mr-2" icon="pi pi-plus" (click)="
            menu = { BusinessId: criteria.BusinessId, Order: total };
            menuDialog = true
          "></button>
        <button pButton label="Options" class="p-button-outlined mr-2" icon="pi pi-list"
          [routerLink]="[basePath, 'menu', criteria.BusinessId, 'option']"></button>
        <button pButton label="Items" class="p-button-outlined mr-2" icon="pi pi-list"
          [routerLink]="[basePath, 'menu', criteria.BusinessId, 'item']"></button>
        <button pButton label="Price Wizard" class="p-button-outlined mr-2" icon="pi pi-sliders-h"
          [routerLink]="[basePath, 'menu', criteria.BusinessId, 'price-wizard']"></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width:3rem"></th>
        <th style="min-width: 12rem">Name</th>
        <th style="width: 5rem"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-menu let-index="rowIndex">
      <tr [pReorderableRow]="index">
        <td class="align-center">
          <span class="pi pi-bars" pReorderableRowHandle></span>
        </td>
        <td>
          <img [src]="menu.UI?.Image" width="30" />
          <span class="image-text ml-2">{{ menu.Name }}</span>
        </td>
        <td>
          <p-menu #actionMenu [model]="menu._actions" [popup]="true" appendTo="body"></p-menu>
          <button pButton [id]="'action-menu-' + menu.Id" type="button" (click)="actionMenu.toggle($event)"
            icon="pi pi-ellipsis-h"></button>
          <!-- <button pButton class="p-button-outlined mr-2" icon="pi pi-arrow-up" title="Move Up"
            (click)="moveMenu(menu, -1)"></button>
          <button pButton class="p-button-outlined mr-2" icon="pi pi-arrow-down" title="Move Down"
            (click)="moveMenu(menu, 1)"></button> -->
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No menu found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <!-- <tr>
        <td colspan="8">Loading menu data. Please wait.</td>
      </tr> -->
      <tr>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
      </tr>
      <tr>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
      </tr>
      <tr>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
        <td><p-skeleton /></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmPopup key="confirmPopup"></p-confirmPopup>

<ng-container *ngIf="menu">
  <p-dialog [header]="(menu.Id ? 'Edit' : 'New') + ' Menu'" [(visible)]="menuDialog" [modal]="true" [maximizable]="true"
    [style]="{ 'min-width': '50vw' }">
    <brt-menu-save [menu]="menu" (saved)="menuDialog = false; load()"></brt-menu-save>
  </p-dialog>
  <p-dialog [header]="menu.Name + ' Menu Default Options'" [(visible)]="menuOptionDialog" [modal]="true"
    [maximizable]="true" appendTo="body" [style]="{ 'min-width': '50vw' }">
    <brt-menu-item-option [(ngModel)]="menu.Options"
      (save)="save(menu); menuOptionDialog = false"></brt-menu-item-option>
  </p-dialog>
  <p-dialog #itemDialog [header]="menu.Name + ' Menu Items'" [(visible)]="menuItemDialog" [modal]="true"
    [maximizable]="true" appendTo="body" [style]="{ 'min-width': '50vw' }" (onShow)="itemDialog.maximize()">
    <brt-menu-item-list [menu-id]="menu.Id"></brt-menu-item-list>
  </p-dialog>
</ng-container>
}